import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-weight-regular opacity-90"
}

import TimeLine from "@/components/misc/TimeLine.vue";
import TaskPanels from "@/components/misc/TaskPanels.vue";
import OrderInformationDialog from "@/components/dialogs/OrderInformationDialog.vue";
import {shallowRef} from "vue";
import {Order, updateOrder} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";

interface EditTab {
  icon: string;
  text: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderDialog',
  props: /*@__PURE__*/_mergeModels({
  onClose: {
    type: Function,
    required: true
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {


const record = _useModel<Order>(__props, "modelValue");

const props = __props;


const currentEditTab = shallowRef<string>('tab-1')
const editTabs: EditTab[] = [
  {
    icon: 'mdi mdi-information-slab-box',
    text: 'Information',
    value: 'tab-1'
  },
  {
    icon: 'mdi mdi-book',
    text: 'Aufgaben',
    value: 'tab-2'
  },
  {
    icon: 'mdi mdi-book-clock-outline',
    text: 'Zeitplan',
    value: 'tab-3'
  },
]

function cancel() {
  useGlobalSetting().hasChanged = false;
  props.onClose?.();
}

function submit() {
  updateOrder(record.value)
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "d-flex flex-column",
    height: "100vh"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { class: "flex-grow-1 overflow-auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            color: "primary",
            density: "compact",
            class: "px-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                icon: "mdi-file-document-multiple",
                class: "mr-2"
              }),
              _createVNode(_component_v_toolbar_title, { class: "text-subtitle-1 font-weight-medium" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(record.value?.id) + " ", 1),
                  (record.value?.title)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, " - " + _toDisplayString(record.value.title), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs, {
            modelValue: currentEditTab.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentEditTab).value = $event)),
            items: editTabs,
            "align-tabs": "center",
            color: "primary",
            height: "60",
            "slider-color": "primary"
          }, {
            tab: _withCtx(({ item }) => [
              _createVNode(_component_v_tab, {
                disabled: record.value.tasks.length == 0 && item.value === 'tab-3',
                "prepend-icon": item.icon,
                text: item.text,
                value: item.value,
                class: "text-none"
              }, null, 8, ["disabled", "prepend-icon", "text", "value"])
            ]),
            item: _withCtx(({ item }) => [
              _createVNode(_component_v_tabs_window_item, {
                value: item.value,
                class: "pa-4"
              }, {
                default: _withCtx(() => [
                  (item.value == 'tab-1')
                    ? (_openBlock(), _createBlock(OrderInformationDialog, {
                        key: 0,
                        modelValue: record.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record).value = $event)),
                        readonly: _unref(useGlobalSetting)().globalReadonly
                      }, null, 8, ["modelValue", "readonly"]))
                    : _createCommentVNode("", true),
                  (item.value == 'tab-2')
                    ? (_openBlock(), _createBlock(TaskPanels, {
                        key: 1,
                        ref: "aufgabenFormRef",
                        modelValue: record.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record).value = $event)),
                        readonly: _unref(useGlobalSetting)().globalReadonly
                      }, null, 8, ["modelValue", "readonly"]))
                    : _createCommentVNode("", true),
                  (item.value == 'tab-3')
                    ? (_openBlock(), _createBlock(TimeLine, {
                        key: 2,
                        modelValue: record.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record).value = $event))
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "bg-surface-light" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "plain",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {cancel(); currentEditTab.value = 'tab-1';})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "red",
                icon: "mdi-cancel",
                start: ""
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" Abbrechen "))
            ]),
            _: 1,
            __: [6]
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            disabled: !_unref(useGlobalSetting)().hasChanged,
            text: "Save",
            onClick: _cache[5] || (_cache[5] = ($event: any) => {submit();})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "green",
                icon: "mdi-checkbox-marked-circle",
                start: ""
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" Speichern "))
            ]),
            _: 1,
            __: [7]
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})